import { createSlice } from "@reduxjs/toolkit";

/**
 * language Redux Slice
 * - 현재 선택된 언어 데이터 관리
 */
const languageSlice = createSlice({
    name: "language",
    initialState: {
        data: null
    },
    reducers: {
        /**
         * 언어 데이터 설정
         * @param {Object} state - 현재 state
         * @param {Object} action - Redux action 객체
         */
        setLanguage: (state, action) => {
            state.data = action.payload;
        }
    }
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;